import { render, staticRenderFns } from "./issue-apply-detail.vue?vue&type=template&id=52b85c26&"
import script from "./issue-apply-detail.vue?vue&type=script&lang=js&"
export * from "./issue-apply-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports